import { render, staticRenderFns } from "./preventEpidemic.vue?vue&type=template&id=a78befb0&"
import script from "./preventEpidemic.vue?vue&type=script&lang=js&"
export * from "./preventEpidemic.vue?vue&type=script&lang=js&"
import style0 from "./preventEpidemic.vue?vue&type=style&index=0&id=a78befb0&prod&scope=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports